import { render, staticRenderFns } from "./TendersPhoneList.vue?vue&type=template&id=d643a500"
import script from "./TendersPhoneList.vue?vue&type=script&lang=js"
export * from "./TendersPhoneList.vue?vue&type=script&lang=js"
import style0 from "./TendersPhoneList.vue?vue&type=style&index=0&id=d643a500&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports